import * as fromNews from './news.reducer';
import * as fromFeatured from './featured-news.reducer';
import { ActionReducerMap, createFeatureSelector, MetaReducer } from '@ngrx/store';
import { environment } from '../../../../environments/environment';

export const featureKey = 'News';

export interface NewsState {
  news: fromNews.NewsState;
  featuredNews: fromFeatured.FeaturedNewsState;
}

export const reducers: ActionReducerMap<NewsState> = {
  news: fromNews.NewsReducer,
  featuredNews: fromFeatured.FeaturedNewsReducer,
};

export const getNewsState = createFeatureSelector<NewsState>(featureKey);

export const metaReducers: MetaReducer<NewsState>[] = !environment.production ? [] : [];
